import { useRef, useState } from "react";
import { adminApi, imgUrl } from "../../lib/api";

export const Field = ({ label, children }) => (
  <div>
    <label className="block text-xs font-semibold text-zinc-500 mb-1.5">{label}</label>
    {children}
  </div>
);

export const inputCls = "w-full border border-zinc-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-zinc-900 bg-white";

export const UploadField = ({ label, value, onChange, accept, testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const isPdf = accept === "application/pdf";
    const okType = isPdf ? f.type === "application/pdf" : ["image/jpeg", "image/png", "image/webp"].includes(f.type);
    if (!okType) {
      setError(isPdf ? "Only PDF files are allowed here." : "Only JPG, PNG or WebP images are allowed here.");
      e.target.value = "";
      return;
    }
    if (f.size > 25 * 1024 * 1024) {
      setError("File too large - maximum 25MB.");
      e.target.value = "";
      return;
    }
    setError("");
    setBusy(true);
    try {
      const res = await adminApi.upload(f);
      onChange(res.url);
    } catch (err) {
      setError(err?.response?.data?.detail || "Upload failed. Please try again.");
    }
    setBusy(false);
    e.target.value = "";
  };
  return (
    <Field label={label}>
      <div className="flex items-center gap-3">
        {value && (value.endsWith(".pdf")
          ? <span className="text-xs text-zinc-500 font-mono truncate max-w-[140px]">{value.split("/").pop()}</span>
          : <img src={imgUrl(value)} alt="" className="w-12 h-12 object-cover rounded border border-zinc-200" />)}
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testId}
          className="text-xs font-semibold border border-zinc-300 rounded-md px-3 py-2 hover:border-zinc-900 disabled:opacity-50">
          {busy ? "Uploading..." : value ? "Replace file" : "Choose file"}
        </button>
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={pick} data-testid={`${testId}-input`} />
      </div>
      {error && <p className="text-xs text-red-600 mt-1.5" data-testid={`${testId}-error`} role="alert">{error}</p>}
    </Field>
  );
};
